import { getSubdomainFranchise } from '../utils/get-subdomain';
import { httpInterceptor } from './http.interceptor';

class LoginService {
  private subdomain: string;

  constructor() {
    this.subdomain = getSubdomainFranchise();
  }

  async checkusernameandpassword(username: string, password: string, franchise: string): Promise<any> {
    try {
      const response = await httpInterceptor.post('/user/login', {
        email: username,
        password: password
      }, {
        headers: {
          'x-api-key': btoa(franchise),
        }
      });

      const data = await response.json();
      
      if (!response.ok) {
        return { error: data };
      }

      return data;
    } catch (erro) {
      return { error: erro };
    }
  }

  async refreshToken(refreshToken: string, email: string): Promise<any> {
    try {
      const response = await httpInterceptor.post('/user/refresh', {
        refreshToken,
        email
      });

      return await response.json();
    } catch (erro) {
      throw erro;
    }
  }
}

export const loginService = new LoginService();
